export default "__VITE_ASSET__430a5b32__"